import React from 'react';
import PropTypes from 'prop-types';

import * as utils from '../utils';

export default function Checkbox (props) {
  const id = props.id || `checkbox#${utils.strings.uuid4()}`;

  const cls = utils.classname('__js-checkbox__ custom-checkbox', {
    'is-disabled': props.disabled,
    'is-read-only': props.readOnly,
    'is-inline': props.inline,
    'is-indeterminate': props.indeterminate,
  }, props.className);

  return (
    <div className={cls} style={props.style}>
      <input
        checked={props.checked}
        type="checkbox"
        name={props.name || id}
        id={id}
        disabled={props.disabled}
        readOnly={props.readOnly}
        onChange={props.onChange}
        {...utils.objects.omit(props, Object.keys(Checkbox.propTypes))}
      />
      <label htmlFor={id} className={cls}>{props.label}</label>
    </div>
  );
}

Checkbox.propTypes = {
  label: PropTypes.node,
  className: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  inline: PropTypes.bool,
  style: PropTypes.object,  // eslint-disable-line react/forbid-prop-types
};
